import { QRCodeSVG as QRCodeSVGImpl } from 'qrcode.react';

type QRCodeSVGProps = {
  value: string;
  size?: number;
  level?: 'L' | 'M' | 'Q' | 'H';
  includeMargin?: boolean;
  bgColor?: string;
  fgColor?: string;
};

/**
 * qrcode.react's types come from a different @types/react (19, hoisted by
 * @hashatar/react) than the demo app (18). Assert through a local wrapper.
 */
export default function QRCodeSVG(props: QRCodeSVGProps) {
  const Component = QRCodeSVGImpl as unknown as (props: QRCodeSVGProps) => JSX.Element;
  return <Component {...props} />;
}
